
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    content: { type: String, required: false }
  }
})
